import React from "react";
import "./timeline.css";

const timelineData = [
  {
    id: 1,
    date: "2012 - 2016",
    title: "Bachelor of Science, Computer Science",
    desc: "Misr International University (MIU) , Cairo",
  },
  {
    id: 2,
    date: "11/2016 - 03/2018 ",
    title: "IT Engineer - Full Time",
    desc: "Joint Venture for Cairo Metro Line 3 Phase 3 , Cairo",
  },
  {
    id: 3,
    date: "03/2018 - 10/2018",
    title: "PHP Developer - Full Time",
    desc: "Softex Software House, Cairo",
  },
  {
    id: 4,
    date: "11/2018 - 01/2020",
    title: "Junior Front End Developer - Full Time",
    desc: "Appcorp, Cairo",
  },
  {
    id: 5,
    date: "02/2020 - 09/2021",
    title: "Senior Front End Developer - Full Time",
    desc: "Appcorp, Cairo",
  },
  {
    id: 6,
    date: "10/2021 - 02/2022",
    title: "Senior Front End Developer - Part Time",
    desc: "Appcorp, Cairo",
  },
  {
    id: 7,
    date: "03/2022 - 08/2023 ",
    title: "Supervisor Full Stack Developer - Full Time",
    desc: "Banque Du Caire, Cairo",
  },
  {
    id: 8,
    date: "09/2023 - Present ",
    title: "Senior Front End Developer - Full Time",
    desc: "_VOIS, Cairo",
  },
];

function Timeline() {
  return (
    <section id="timeline">
      <h5>A Short Resume</h5>
      <h2>My Timeline</h2>
      <div className="container ">
        <div className="timeline__container">
          {timelineData.reverse().map((data) => (
            <article
              key={data.id}
              data-aos="flip-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <h5>{data.date}</h5>
              <h4>{data.title}</h4>
              <small>{data.desc}</small>
            </article>
          ))}

          <div className="vertical"></div>
        </div>
      </div>
    </section>
  );
}

export default Timeline;
